export interface IGridSettings {
    wordWrapMode: GridWordWrapMode;
    defaultPredefinedFilter?: string;
}

export enum GridWordWrapMode {
    // Не переносить (в одну строку)
    NoWrap,
    // Ограничение количества строк
    Trim,
    // Переносить
    Wrap,
}
